module.exports = "/_next/static/resources/zoe-mesnik-greene-cf792050cb7c640efea0080352370733.webp";